<kendo-grid [loading]='kendoLoading' [data]="gridData"  [navigable]="true" kendoGridFocusable>
  <kendo-grid-column field="IsActive" title="Active">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <span *ngIf="dataItem.IsActive">Yes</span>
      <span *ngIf="!dataItem.IsActive">No</span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="CompanyAddress" title="Address">
  </kendo-grid-column>
  <kendo-grid-column field="IsEmailVerified" title="Email-Verify">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <span *ngIf="dataItem.IsEmailVerified">Yes</span>
      <span *ngIf="!dataItem.IsEmailVerified">No</span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="IsTestAccount" title="TestAccount">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <span *ngIf="dataItem.IsTestAccount">Yes</span>
      <span *ngIf="!dataItem.IsTestAccount">No</span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="MigrationStatus" title="Migration Status" [class]="{ 'text-center': true }">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span *ngIf="dataItem.MigrationStatus == 'Success'" class="badge badge-success">Success</span>
      <span *ngIf="dataItem.MigrationStatus == 'Failed'" class="badge badge-danger">Failed</span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="MigrationVersionInfo" title="Migration Version Info">
  </kendo-grid-column>
  <kendo-grid-column field="CreatedDate" title="Created Date">
  </kendo-grid-column>

  <kendo-grid-column field="IPAddress" title="IP Address">
  </kendo-grid-column>
  <kendo-grid-column field="IPLocation" title="IP Location">
  </kendo-grid-column>
</kendo-grid>